import { Users } from 'lucide-react'
import { useLanguage } from '@/hooks/useLanguage'
import { betaT } from '../locale'

interface Props {
  queueCount: number | undefined
  onStart: () => void
}

export const BetaInfo = ({ queueCount, onStart }: Props) => {
  const { language } = useLanguage()
  const l = betaT[language]

  // white by design: renders on the fixed-dark Beta hero (BetaLayout), not app surface
  return (
    <>
      <img src="/wait-list-await.webp" alt="" className="w-[84px] h-[84px] mb-4 mx-auto" />
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white mb-3">
        {l.betaTitle}
      </h1>
      <p className="text-sm text-white/60 mb-2">{l.betaDesc}</p>
      <div className="flex items-center gap-2 text-sm text-white/50 mb-8">
        <Users className="w-4 h-4" />
        <span>
          {l.inQueue} <span className="font-medium text-white/80">{queueCount ?? '–'}</span>{' '}
          {l.people(queueCount ?? null)}
        </span>
      </div>
      <button
        type="button"
        onClick={onStart}
        className="w-full h-11 rounded-xl bg-white hover:bg-white/90 text-[#0E0E12] font-medium text-sm transition-all duration-200 hover:scale-[1.02] disabled:opacity-50 disabled:pointer-events-none flex items-center justify-center gap-2"
      >
        {l.earlyAccess}
      </button>
    </>
  )
}
